<template>
  <div v-if="countries">
    <a class="theme-btn theme-btn-small mb-3" @click="addPassenger">+Add Passenger</a>

    <div class="row">
      <div class="col-lg-12" >
        <div class="form-box" v-for="(passenger,index) in passengers">
            <div class="form-title-wrap">
              <h3 class="title">{{index+1}}. Yolcu</h3>

              <a class="theme-btn theme-btn-small" @click="remove(passenger)">Çıkar</a>
            </div><!-- form-title-wrap -->
            <div class="form-content ">
              <div class="contact-form-action">
                <form :id="'passenger-'+index">
                  <div class="row align-items-end">
                    <div class="col-7 col-sm-6">
                      <div class="input-box">
                        <div class="form-group">
                          <div class="select-contain w-auto">
                            <v-app>
                              <v-autocomplete :filter="filterCruiseRooms"
                                              :items="filteredCruiseRoomList"
                                              v-model="passenger.cruiseRoomId"
                                              flat hide-no-data
                                              hide-details
                                              item-value="id"
                                              placeholder="Kabin">
                                <template slot="selection" slot-scope="{ item, selected }">
                                  {{item.roomNumber}} {{item.ros ? '(ROS)' : ''}} - {{  getRoomName(item.roomId) }}
                                </template>
                                <template slot="item" slot-scope="{ item, tile }">
                                  <v-list-tile-content>
                                    {{item.roomNumber}} {{item.ros ? '(ROS)' : ''}} - {{  getRoomName(item.roomId) }}
                                  </v-list-tile-content>
                                </template>
                              </v-autocomplete>
                            </v-app>
                          </div>
                        </div>
                      </div>
                    </div><!-- end col-md-6 -->
                    <div class="col-5 col-md-3">
                      <div class="input-box">
                        <div class="form-group">
                          <cabin-view-popup></cabin-view-popup>
                        </div>
                      </div>
                    </div><!-- end col-md-3 -->
                  </div>
                  <div class="row">
                    <div class="col-lg-6 responsive-column">
                      <base-edit-input
                          v-model="passenger.name"
                          :rules="'required'"
                          :type="'text'"
                          :label="'İsim'"
                      ></base-edit-input>
                    </div><!-- end col-lg-6 -->
                    <div class="col-lg-6 responsive-column">
                      <base-edit-input
                          v-model="passenger.lastName"
                          :rules="'required'"
                          :type="'text'"
                          :label="'Soyisim'"
                      ></base-edit-input>
                    </div><!-- end col-lg-6 -->
                    <div class="col-lg-6 responsive-column">
                      <base-date-input
                        v-model="passenger.birthDate"
                        :rules="'birthdate'"
                        :type="'text'"
                        :label="'Doğum Tarihi'">
                      </base-date-input>
                    </div><!-- end col-lg-6 -->
                    <div class="col-lg-6 responsive-column">
                      <base-select-input
                          v-model="passenger.gender"
                          :optionList="[{name:'Female',id:'female'},{name:'Male',id:'male'}]"
                          :rules="'required'"
                          :type="'text'"
                          :label="'Cinsiyet'"
                      ></base-select-input>
                    </div>
<!--                    <div class="col-lg-12">-->
<!--                      <div class="input-box">-->
<!--                        <div class="form-group">-->
<!--                          <div class="custom-checkbox mb-0">-->
<!--                            <input type="checkbox" :id="'tcNo'+index" class="isTurkishCitizen" v-model="passenger.isTurkishCitizen" @change="isTurkishCitizenChange(passenger)">-->
<!--                            <label :for="'tcNo'+index" data-toggle="collapse" aria-expanded="false">T.C. Vatandaşı</label>-->
<!--                          </div>-->
<!--                        </div>-->
<!--                      </div>-->
<!--                    </div>-->
                    <div class="col-lg-6 responsive-column">
                      <base-edit-input
                          v-model="passenger.tckNo"
                          :type="'text'"
                          :label="'TC'"
                      ></base-edit-input>
                    </div>
                    <div class="col-lg-6 responsive-column" v-if="!passenger.isTurkishCitizen || countries">
                      <base-select-input
                          v-if="projectName === 'selectum'"
                          v-model="passenger.country"
                          :optionList="countries"
                          :id-key="'code2'"
                          :type="'text'"
                          :label="'Ülke'"
                      ></base-select-input>
                      <base-select-input
                          v-if="projectName === 'miray'"
                          v-model="passenger.country"
                          :optionList="countries"
                          :id-key="'id'"
                          :type="'text'"
                          :label="'Ülke'"
                      ></base-select-input>
                    </div>
                  </div>
                  <div class="passoport" :class="passenger.isTurkishCitizen" :attr="passenger.isTurkishCitizen">
                    <div class="row">
                      <div class="col-lg-6 responsive-column">
                        <base-edit-input
                            v-model="passenger.passportNumber"
                            :type="'text'"
                            :label="'Passaport No'"
                        ></base-edit-input>
                      </div><!-- end col-lg-6 -->
                      <div class="col-lg-6 responsive-column">
                        <base-select-input
                            v-model="passenger.passportType"
                            :optionList="[{name:'Bordo',id:'Bordo'},{name:'Yesil',id:'Yesil'},{name:'Gri',id:'Gri'},{name:'Siyah',id:'Siyah'},{name:'Kırmızı',id:'Kırmızı'}]"
                            :type="'text'"
                            :label="'Passaport Türü *'"
                        ></base-select-input>
                      </div><!-- end col-lg-6 -->
                      <div class="col-lg-6 responsive-column">
                        <base-date-input
                            v-model="passenger.issueDate"
                            :type="'text'"
                            :label="'Veriliş Tarihi'">
                        </base-date-input>
                      </div><!-- end col-lg-6 -->
                      <div class="col-lg-6 responsive-column">
                        <base-date-input
                            v-model="passenger.expireDate"
                            :type="'text'"
                            :label="'Son Geçerlilik Tarihi'">
                        </base-date-input>
                      </div><!-- end col-lg-6 -->
                      <div class="col-lg-6 responsive-column">
                        <base-edit-input
                            v-model="passenger.issuedPlace"
                            :type="'text'"
                            :label="'Verildiği Yer'"
                        ></base-edit-input>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
        </div>
      </div>
    </div>
    <div class="row mt-4">
      <div class="col-lg-12">
        <div class="form-box">
          <div class="form-title-wrap">
            <h3 class="title">İletişim Bilgileri</h3>
          </div><!-- form-title-wrap -->
          <div class="form-content ">
            <div class="contact-form-action">
              <form id="contactForm">
                <div class="row">
                  <div class="col-lg-4 responsive-column">
                    <base-edit-input
                        v-model="contactName"
                        :rules="'required'"
                        :type="'text'"
                        :label="'İsim Soyisim'"
                    ></base-edit-input>
                  </div>
                  <div class="col-lg-4 responsive-column">
                    <base-edit-input
                        v-model="contactEmail"
                        :rules="'required'"
                        :type="'text'"
                        :label="'Eposta'"
                    ></base-edit-input>
                  </div>
                  <div class="col-lg-4 responsive-column">
                    <base-phone-input
                      v-model="contactPhone"
                      uu-id="contactPhone"
                      :label="'Telefon Numarası'">
                    </base-phone-input>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row mt-4" v-if="projectName === 'miray'">
      <div class="col-lg-12">
        <div class="form-box">
          <div class="form-title-wrap">
            <h3 class="title">Acil Durum Kişisi Bilgileri</h3>
          </div><!-- form-title-wrap -->
          <div class="form-content ">
            <div class="contact-form-action">
              <form id="emergencyForm">
                <div class="row">
                  <div class="col-lg-4 responsive-column">
                    <base-edit-input
                        v-model="emergencyContactName"
                        :type="'text'"
                        :label="'İsim Soyisim'"
                    ></base-edit-input>
                  </div>
                  <div class="col-lg-4 responsive-column">
                    <base-edit-input
                        v-model="emergencyContactEmail"
                        :type="'text'"
                        :label="'Eposta'"
                    ></base-edit-input>
                  </div>
                  <div class="col-lg-4 responsive-column">
                    <base-phone-input
                        v-model="emergencyContactPhone"
                        uu-id="emergencyContactPhone"
                        :label="'Telefon Numarası'">
                    </base-phone-input>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import CabinViewPopup from "./CabinViewPopup";
import generalValidation from "../../util/generalValidation";
import BaseSelectInput from "../base/BaseSelectInput";
import CruiseRoomBaseSelectInput from "../base/CruiseRoomBaseSelectInput";
import BaseEditInput from "../base/BaseEditInput";
import BaseDateInput from "../base/BaseDateInput";
import validationFormUtils from "../../util/validationFormUtils";
import BasePhoneInput from "../base/BasePhoneInput";

export default {
  name: "passengerInformation",
  components: {
    BasePhoneInput,
    BaseDateInput, BaseEditInput, CruiseRoomBaseSelectInput, BaseSelectInput, CabinViewPopup},
  data:function (){
    return{
      filter:'',
      countries: null
    }
  },
  beforeCreate() {
    this.$store.dispatch("loadCruise").then(()=>{
      this.$store.dispatch("loadRoomList")
    });
  },
  methods:{
    getRoomName:function (roomId){
      if(this.roomMap === null){
        return "";
      }
      return this.roomMap[roomId].name;
    },
    filterCruiseRooms(row, searchTerm){
      let roomNumber = row.roomNumber;
      let splitSearchTerm = searchTerm.toLowerCase().split(" ");

      let matchCount = 0;
      splitSearchTerm.forEach(searchTerm=> {
        if(roomNumber.includes(searchTerm) || this.roomMap[row.roomId].name.toLowerCase().includes(searchTerm)){
          matchCount++;
        }
      })
      return matchCount === splitSearchTerm.length;
    },
    getRule(passenger,want){
      if (passenger.isTurkishCitizen === want){
        return 'required'
      }
    },
    getTCRule(passenger){
      if (passenger.isTurkishCitizen){
        return 'tc_validation'
      }
    },
    getPassportRule(passenger){
      if (!passenger.isTurkishCitizen){
        return 'required'
      }
    },
    isTurkishCitizenChange(passenger){
      passenger.lastName += " "
      passenger.lastName = passenger.lastName.trim();
      if(passenger.expireDate == null){
        passenger.expireDate = new Date(new Date().setYear(1990))
      }
      if(passenger.issueDate == null){
        passenger.issueDate = new Date(new Date().setYear(1990))
      }
      $('.birthDatePassengerInformation').mask('00/00/0000');
      $('.passportExpDate').mask('00/00/0000');
      $('.passportGiveDate').mask('00/00/0000');
    },
    checkValid(){
      validationFormUtils.checkFormFields(this);
    },
    checkFormFieldsSync(){
      return validationFormUtils.checkFormFieldsSync(this);
    },
    validateChilds(){
      return validationFormUtils.validateChilds(this);
    },
    addPassenger(){
      let passengers = this.$store.getters.getPassengers;
      passengers.push({
        type:"Yetişkin",
        passengerType : "ADULT",
        isTurkishCitizen:true,
        birthDate:new Date(new Date().setYear(1990)),
        expireDate:new Date(new Date().setYear(1990)),
        issueDate:new Date(new Date().setYear(1990))
      })
      this.$store.commit("setPassengers",passengers)
      let thatIndex = passengers.length;
      setTimeout(function (){
        $('html, body').animate({
          scrollTop: $("#passenger-"+(thatIndex-1)).offset().top-75
        }, 500);

        generalValidation.validateForm("passenger-"+thatIndex);

      },200)
    },
    remove(passenger){
      let passengers = this.passengers
      let thatPassenger = passenger;
      Swal.fire({
        title: "Emin Misin?",
        text: "Yolcuyu Rezervasyondan Çıkartmak istediğinize Emin misiniz!",
        icon: "warning",
        buttons: [
          'İptal!',
          'Onaylıyorum!'
        ],
        dangerMode: true,
      }).then(function(isConfirm) {
        if (isConfirm.isConfirmed) {
          Swal.fire({
            title: 'Başarılı!',
            text: 'Yolcuyu rezervasyondan Başarı ile çıkarttınız!',
            icon: 'success'
          }).then(function () {
            passengers.splice(passengers.indexOf(thatPassenger),1);
          });
        } else {
          Swal.fire("İptal edildi", "", "error");
        }
      })
    },
  },

  computed: {
    projectName:{
      get(){
        return this.$store.getters.getProjectName;
      }
    },
    formValid:{
      get(){
        return this.$store.getters.getPassengerEditValidation
      },
      set(value){
        return this.$store.commit("setPassengerEditValidation",value)
      }
    },
    cruiseRoomList: {
      get() {
        return this.$store.getters.getCruiseRoomList;
      }
    },
    passengers: {
      get() {
        return this.$store.getters.getPassengers;
      },
      set(value){
        this.commit("setPassengers",value);
      }
    },
    sail: {
      get() {
        return this.$store.getters.getSail
      }
    },
    booking : {
      get(){
        return this.$store.getters.getBooking;
      }
    },
    contactPhone : {
      get(){
        return this.$store.getters.getContactPhone;
      },
      set(value){
        this.$store.commit("setContactPhone",value);
      }
    },
    contactEmail : {
      get(){
        return this.$store.getters.getContactEmail;
      },
      set(value){
        this.$store.commit("setContactEmail",value);
      }
    },
    contactName : {
      get(){
        return this.$store.getters.getContactName;
      },
      set(value){
        this.$store.commit("setContactName",value);
      }
    },

    emergencyContactPhone : {
      get(){
        return this.$store.getters.getEmergencyContactPhone;
      },
      set(value){
        this.$store.commit("setEmergencyContactPhone",value);
      }
    },
    emergencyContactEmail : {
      get(){
        return this.$store.getters.getEmergencyContactEmail;
      },
      set(value){
        this.$store.commit("setEmergencyContactEmail",value);
      }
    },
    emergencyContactName : {
      get(){
        return this.$store.getters.getEmergencyContactName;
      },
      set(value){
        this.$store.commit("setEmergencyContactName",value);
      }
    },

    myCruiseRoomId : {
      get(){
        let sail = this.sail
        //Group by cabinType
        let map = {}
        for(let i=0;i<sail.rooms.length;i++) {
          for(let j=0;j<sail.rooms[i].cruiseRooms.length;j++){
            map[sail.rooms[i].cruiseRooms[j].id] = sail.rooms[i]
          }
        }
        return map
      }
    },

    roomList:{
      get(){
        return this.$store.getters.getRoomList;
      }
    },
    roomMap:{
      get(){
        let roomList = this.$store.getters.getRoomList;
        if(roomList == null){
          return null;
        }
        return roomList.reduce(function (map, cabinType) {
          map[cabinType.id] = cabinType;
          return map;
        }, {});
      }
    },
    filteredCruiseRoomList : {
      get(){
        if(this.cruiseRoomList !== null && this.roomList !== null && this.roomMap !== null) {
          return this.cruiseRoomList.filter(row => {

            let roomNumber = row.roomNumber;
            let splitSearchTerm = this.filter.toLowerCase().split(" ");

            let matchCount = 0;
            splitSearchTerm.forEach(searchTerm=> {
              if(roomNumber.includes(searchTerm) || this.roomMap[row.roomId].name.toLowerCase().includes(searchTerm)){
                matchCount++;
              }
            })
            return matchCount === splitSearchTerm.length;
          });
        }
      }
    },
  },
  // watch:{
  //   contactName:{
  //     deep:true,
  //     handler:function (){
  //       this.checkValid();
  //     }
  //   },
  //   contactEmail:{
  //     deep:true,
  //     handler:function (){
  //       this.checkValid();
  //     }
  //   },
  //   contactPhone:{
  //     deep:true,
  //     handler:function (){
  //       this.checkValid();
  //     }
  //   },
  //   // passengers:{
  //   //   deep:true,
  //   //   handler:function (value,oldValue){
  //   //     // if(oldValue.length == 0){
  //   //     // }else {
  //   //       this.checkValid()
  //   //     // }
  //   //   }
  //   // }
  // },
  mounted() {
    if(this.projectName === 'miray'){

      this.countries = [{"name":"Turkey","id":"TUR","country-code":"792"},{"name":"Åland Islands","id":"ALA","country-code":"248"},{"name":"Albania","id":"ALB","country-code":"008"},{"name":"Algeria","id":"DZA","country-code":"012"},{"name":"American Samoa","id":"ASM","country-code":"016"},{"name":"Andorra","id":"AND","country-code":"020"},{"name":"Angola","id":"AGO","country-code":"024"},{"name":"Anguilla","id":"AIA","country-code":"660"},{"name":"Antarctica","id":"ATA","country-code":"010"},{"name":"Antigua and Barbuda","id":"ATG","country-code":"028"},{"name":"Argentina","id":"ARG","country-code":"032"},{"name":"Armenia","id":"ARM","country-code":"051"},{"name":"Aruba","id":"ABW","country-code":"533"},{"name":"Australia","id":"AUS","country-code":"036"},{"name":"Austria","id":"AUT","country-code":"040"},{"name":"Azerbaijan","id":"AZE","country-code":"031"},{"name":"Bahamas","id":"BHS","country-code":"044"},{"name":"Bahrain","id":"BHR","country-code":"048"},{"name":"Bangladesh","id":"BGD","country-code":"050"},{"name":"Barbados","id":"BRB","country-code":"052"},{"name":"Belarus","id":"BLR","country-code":"112"},{"name":"Belgium","id":"BEL","country-code":"056"},{"name":"Belize","id":"BLZ","country-code":"084"},{"name":"Benin","id":"BEN","country-code":"204"},{"name":"Bermuda","id":"BMU","country-code":"060"},{"name":"Bhutan","id":"BTN","country-code":"064"},{"name":"Bolivia (Plurinational State of)","id":"BOL","country-code":"068"},{"name":"Bonaire, Sint Eustatius and Saba","id":"BES","country-code":"535"},{"name":"Bosnia and Herzegovina","id":"BIH","country-code":"070"},{"name":"Botswana","id":"BWA","country-code":"072"},{"name":"Bouvet Island","id":"BVT","country-code":"074"},{"name":"Brazil","id":"BRA","country-code":"076"},{"name":"British Indian Ocean Territory","id":"IOT","country-code":"086"},{"name":"Brunei Darussalam","id":"BRN","country-code":"096"},{"name":"Bulgaria","id":"BGR","country-code":"100"},{"name":"Burkina Faso","id":"BFA","country-code":"854"},{"name":"Burundi","id":"BDI","country-code":"108"},{"name":"Cabo Verde","id":"CPV","country-code":"132"},{"name":"Cambodia","id":"KHM","country-code":"116"},{"name":"Cameroon","id":"CMR","country-code":"120"},{"name":"Canada","id":"CAN","country-code":"124"},{"name":"Cayman Islands","id":"CYM","country-code":"136"},{"name":"Central African Republic","id":"CAF","country-code":"140"},{"name":"Chad","id":"TCD","country-code":"148"},{"name":"Chile","id":"CHL","country-code":"152"},{"name":"China","id":"CHN","country-code":"156"},{"name":"Christmas Island","id":"CXR","country-code":"162"},{"name":"Cocos (Keeling) Islands","id":"CCK","country-code":"166"},{"name":"Colombia","id":"COL","country-code":"170"},{"name":"Comoros","id":"COM","country-code":"174"},{"name":"Congo","id":"COG","country-code":"178"},{"name":"Congo, Democratic Republic of the","id":"COD","country-code":"180"},{"name":"Cook Islands","id":"COK","country-code":"184"},{"name":"Costa Rica","id":"CRI","country-code":"188"},{"name":"Côte d'Ivoire","id":"CIV","country-code":"384"},{"name":"Croatia","id":"HRV","country-code":"191"},{"name":"Cuba","id":"CUB","country-code":"192"},{"name":"Curaçao","id":"CUW","country-code":"531"},{"name":"Cyprus","id":"CYP","country-code":"196"},{"name":"Czechia","id":"CZE","country-code":"203"},{"name":"Denmark","id":"DNK","country-code":"208"},{"name":"Djibouti","id":"DJI","country-code":"262"},{"name":"Dominica","id":"DMA","country-code":"212"},{"name":"Dominican Republic","id":"DOM","country-code":"214"},{"name":"Ecuador","id":"ECU","country-code":"218"},{"name":"Egypt","id":"EGY","country-code":"818"},{"name":"El Salvador","id":"SLV","country-code":"222"},{"name":"Equatorial Guinea","id":"GNQ","country-code":"226"},{"name":"Eritrea","id":"ERI","country-code":"232"},{"name":"Estonia","id":"EST","country-code":"233"},{"name":"Eswatini","id":"SWZ","country-code":"748"},{"name":"Ethiopia","id":"ETH","country-code":"231"},{"name":"Falkland Islands (Malvinas)","id":"FLK","country-code":"238"},{"name":"Faroe Islands","id":"FRO","country-code":"234"},{"name":"Fiji","id":"FJI","country-code":"242"},{"name":"Finland","id":"FIN","country-code":"246"},{"name":"France","id":"FRA","country-code":"250"},{"name":"French Guiana","id":"GUF","country-code":"254"},{"name":"French Polynesia","id":"PYF","country-code":"258"},{"name":"French Southern Territories","id":"ATF","country-code":"260"},{"name":"Gabon","id":"GAB","country-code":"266"},{"name":"Gambia","id":"GMB","country-code":"270"},{"name":"Georgia","id":"GEO","country-code":"268"},{"name":"Germany","id":"DEU","country-code":"276"},{"name":"Ghana","id":"GHA","country-code":"288"},{"name":"Gibraltar","id":"GIB","country-code":"292"},{"name":"Greece","id":"GRC","country-code":"300"},{"name":"Greenland","id":"GRL","country-code":"304"},{"name":"Grenada","id":"GRD","country-code":"308"},{"name":"Guadeloupe","id":"GLP","country-code":"312"},{"name":"Guam","id":"GUM","country-code":"316"},{"name":"Guatemala","id":"GTM","country-code":"320"},{"name":"Guernsey","id":"GGY","country-code":"831"},{"name":"Guinea","id":"GIN","country-code":"324"},{"name":"Guinea-Bissau","id":"GNB","country-code":"624"},{"name":"Guyana","id":"GUY","country-code":"328"},{"name":"Haiti","id":"HTI","country-code":"332"},{"name":"Heard Island and McDonald Islands","id":"HMD","country-code":"334"},{"name":"Holy See","id":"VAT","country-code":"336"},{"name":"Honduras","id":"HND","country-code":"340"},{"name":"Hong Kong","id":"HKG","country-code":"344"},{"name":"Hungary","id":"HUN","country-code":"348"},{"name":"Iceland","id":"ISL","country-code":"352"},{"name":"India","id":"IND","country-code":"356"},{"name":"Indonesia","id":"IDN","country-code":"360"},{"name":"Ireland","id":"IRL","country-code":"372"},{"name":"Isle of Man","id":"IMN","country-code":"833"},{"name":"Israel","id":"ISR","country-code":"376"},{"name":"Italy","id":"ITA","country-code":"380"},{"name":"Jamaica","id":"JAM","country-code":"388"},{"name":"Japan","id":"JPN","country-code":"392"},{"name":"Jersey","id":"JEY","country-code":"832"},{"name":"Jordan","id":"JOR","country-code":"400"},{"name":"Kazakhstan","id":"KAZ","country-code":"398"},{"name":"Kenya","id":"KEN","country-code":"404"},{"name":"Kiribati","id":"KIR","country-code":"296"},{"name":"Korea (Democratic People's Republic of)","id":"PRK","country-code":"408"},{"name":"Korea, Republic of","id":"KOR","country-code":"410"},{"name":"Kuwait","id":"KWT","country-code":"414"},{"name":"Kyrgyzstan","id":"KGZ","country-code":"417"},{"name":"Lao People's Democratic Republic","id":"LAO","country-code":"418"},{"name":"Latvia","id":"LVA","country-code":"428"},{"name":"Lebanon","id":"LBN","country-code":"422"},{"name":"Lesotho","id":"LSO","country-code":"426"},{"name":"Liberia","id":"LBR","country-code":"430"},{"name":"Libya","id":"LBY","country-code":"434"},{"name":"Liechtenstein","id":"LIE","country-code":"438"},{"name":"Lithuania","id":"LTU","country-code":"440"},{"name":"Luxembourg","id":"LUX","country-code":"442"},{"name":"Macao","id":"MAC","country-code":"446"},{"name":"Madagascar","id":"MDG","country-code":"450"},{"name":"Malawi","id":"MWI","country-code":"454"},{"name":"Malaysia","id":"MYS","country-code":"458"},{"name":"Maldives","id":"MDV","country-code":"462"},{"name":"Mali","id":"MLI","country-code":"466"},{"name":"Malta","id":"MLT","country-code":"470"},{"name":"Marshall Islands","id":"MHL","country-code":"584"},{"name":"Martinique","id":"MTQ","country-code":"474"},{"name":"Mauritania","id":"MRT","country-code":"478"},{"name":"Mauritius","id":"MUS","country-code":"480"},{"name":"Mayotte","id":"MYT","country-code":"175"},{"name":"Mexico","id":"MEX","country-code":"484"},{"name":"Micronesia (Federated States of)","id":"FSM","country-code":"583"},{"name":"Moldova, Republic of","id":"MDA","country-code":"498"},{"name":"Monaco","id":"MCO","country-code":"492"},{"name":"Mongolia","id":"MNG","country-code":"496"},{"name":"Montenegro","id":"MNE","country-code":"499"},{"name":"Montserrat","id":"MSR","country-code":"500"},{"name":"Morocco","id":"MAR","country-code":"504"},{"name":"Mozambique","id":"MOZ","country-code":"508"},{"name":"Myanmar","id":"MMR","country-code":"104"},{"name":"Namibia","id":"NAM","country-code":"516"},{"name":"Nauru","id":"NRU","country-code":"520"},{"name":"Nepal","id":"NPL","country-code":"524"},{"name":"Netherlands","id":"NLD","country-code":"528"},{"name":"New Caledonia","id":"NCL","country-code":"540"},{"name":"New Zealand","id":"NZL","country-code":"554"},{"name":"Nicaragua","id":"NIC","country-code":"558"},{"name":"Niger","id":"NER","country-code":"562"},{"name":"Nigeria","id":"NGA","country-code":"566"},{"name":"Niue","id":"NIU","country-code":"570"},{"name":"Norfolk Island","id":"NFK","country-code":"574"},{"name":"North Macedonia","id":"MKD","country-code":"807"},{"name":"Northern Mariana Islands","id":"MNP","country-code":"580"},{"name":"Norway","id":"NOR","country-code":"578"},{"name":"Oman","id":"OMN","country-code":"512"},{"name":"Palau","id":"PLW","country-code":"585"},{"name":"Palestine, State of","id":"PSE","country-code":"275"},{"name":"Panama","id":"PAN","country-code":"591"},{"name":"Papua New Guinea","id":"PNG","country-code":"598"},{"name":"Paraguay","id":"PRY","country-code":"600"},{"name":"Peru","id":"PER","country-code":"604"},{"name":"Philippines","id":"PHL","country-code":"608"},{"name":"Pitcairn","id":"PCN","country-code":"612"},{"name":"Poland","id":"POL","country-code":"616"},{"name":"Portugal","id":"PRT","country-code":"620"},{"name":"Puerto Rico","id":"PRI","country-code":"630"},{"name":"Qatar","id":"QAT","country-code":"634"},{"name":"Réunion","id":"REU","country-code":"638"},{"name":"Romania","id":"ROU","country-code":"642"},{"name":"Russian Federation","id":"RUS","country-code":"643"},{"name":"Rwanda","id":"RWA","country-code":"646"},{"name":"Saint Barthélemy","id":"BLM","country-code":"652"},{"name":"Saint Helena, Ascension and Tristan da Cunha","id":"SHN","country-code":"654"},{"name":"Saint Kitts and Nevis","id":"KNA","country-code":"659"},{"name":"Saint Lucia","id":"LCA","country-code":"662"},{"name":"Saint Martin (French part)","id":"MAF","country-code":"663"},{"name":"Saint Pierre and Miquelon","id":"SPM","country-code":"666"},{"name":"Saint Vincent and the Grenadines","id":"VCT","country-code":"670"},{"name":"Samoa","id":"WSM","country-code":"882"},{"name":"San Marino","id":"SMR","country-code":"674"},{"name":"Sao Tome and Principe","id":"STP","country-code":"678"},{"name":"Saudi Arabia","id":"SAU","country-code":"682"},{"name":"Senegal","id":"SEN","country-code":"686"},{"name":"Serbia","id":"SRB","country-code":"688"},{"name":"Seychelles","id":"SYC","country-code":"690"},{"name":"Sierra Leone","id":"SLE","country-code":"694"},{"name":"Singapore","id":"SGP","country-code":"702"},{"name":"Sint Maarten (Dutch part)","id":"SXM","country-code":"534"},{"name":"Slovakia","id":"SVK","country-code":"703"},{"name":"Slovenia","id":"SVN","country-code":"705"},{"name":"Solomon Islands","id":"SLB","country-code":"090"},{"name":"Somalia","id":"SOM","country-code":"706"},{"name":"South Africa","id":"ZAF","country-code":"710"},{"name":"South Georgia and the South Sandwich Islands","id":"SGS","country-code":"239"},{"name":"South Sudan","id":"SSD","country-code":"728"},{"name":"Spain","id":"ESP","country-code":"724"},{"name":"Sri Lanka","id":"LKA","country-code":"144"},{"name":"Sudan","id":"SDN","country-code":"729"},{"name":"Suriname","id":"SUR","country-code":"740"},{"name":"Svalbard and Jan Mayen","id":"SJM","country-code":"744"},{"name":"Sweden","id":"SWE","country-code":"752"},{"name":"Switzerland","id":"CHE","country-code":"756"},{"name":"Taiwan, Province of China","id":"TWN","country-code":"158"},{"name":"Tajikistan","id":"TJK","country-code":"762"},{"name":"Tanzania, United Republic of","id":"TZA","country-code":"834"},{"name":"Thailand","id":"THA","country-code":"764"},{"name":"Timor-Leste","id":"TLS","country-code":"626"},{"name":"Togo","id":"TGO","country-code":"768"},{"name":"Tokelau","id":"TKL","country-code":"772"},{"name":"Tonga","id":"TON","country-code":"776"},{"name":"Trinidad and Tobago","id":"TTO","country-code":"780"},{"name":"Tunisia","id":"TUN","country-code":"788"},{"name":"Turkmenistan","id":"TKM","country-code":"795"},{"name":"Turks and Caicos Islands","id":"TCA","country-code":"796"},{"name":"Tuvalu","id":"TUV","country-code":"798"},{"name":"Uganda","id":"UGA","country-code":"800"},{"name":"Ukraine","id":"UKR","country-code":"804"},{"name":"United Arab Emirates","id":"ARE","country-code":"784"},{"name":"United Kingdom of Great Britain and Northern Ireland","id":"GBR","country-code":"826"},{"name":"United States of America","id":"USA","country-code":"840"},{"name":"United States Minor Outlying Islands","id":"UMI","country-code":"581"},{"name":"Uruguay","id":"URY","country-code":"858"},{"name":"Vanuatu","id":"VUT","country-code":"548"},{"name":"Venezuela (Bolivarian Republic of)","id":"VEN","country-code":"862"},{"name":"Viet Nam","id":"VNM","country-code":"704"},{"name":"Virgin Islands (British)","id":"VGB","country-code":"092"},{"name":"Virgin Islands (U.S.)","id":"VIR","country-code":"850"},{"name":"Wallis and Futuna","id":"WLF","country-code":"876"},{"name":"Western Sahara","id":"ESH","country-code":"732"},{"name":"Yemen","id":"YEM","country-code":"887"},{"name":"Zambia","id":"ZMB","country-code":"894"},{"name":"Zimbabwe","id":"ZWE","country-code":"716"}]
    }else{
      this.$store.dispatch("loadCountryList").then(response => {
        this.countries = response;
      })
    }

    this.checkValid();
    setTimeout(function (){
      $(".select-contain-select").selectpicker('refresh');
    },500)
    $(".select-contain-select").selectpicker({
      size: 5,
      noneSelectedText: 'Select One'
    });

  },
}
</script>

<style scoped>
.dropdown-menu {
  z-index:10030 !important;
}
</style>